<template>
  <FlotoDropdownPicker
    :value="value"
    :search-fn="searchTargetEnvironments"
    :disabled="disabled"
    :multiple="multiple"
    as-input
    immediate-search
    :transform-options-fn="transformTargetEnvironment"
    v-bind="$attrs"
    @change="$emit('change', $event || 0)"
    v-on="listeners"
  />
</template>

<script>
import { getTargetEnvironmentsApi } from '@modules/change-management/change-management-api'
export default {
  name: 'FlotoTargetEnvironmentPicker',
  model: { event: 'change' },
  props: {
    value: { type: [Number, String, Array], default: undefined },
    disabled: { type: Boolean, default: false },
    validateArchivedValue: { type: Boolean, default: false },
    multiple: { type: Boolean, default: false },
  },
  data() {
    this.unassignedValue = 0
    this.selectedValueOptions = []
    return {
      isDirty: false,
    }
  },
  computed: {
    listeners() {
      const { change, ...listeners } = this.$listeners
      return listeners
    },
  },
  methods: {
    transformTargetEnvironment({ items }) {
      if (
        items.length > 0 &&
        this.value &&
        this.validateArchivedValue &&
        !this.multiple &&
        items.filter((i) => i.key === this.value && !i.archived).length === 0
      ) {
        this.$emit('change', 0)
      }
      return items.map((f) => ({
        text: f.name,
        key: f.id,
        id: f.id,
        archived: f.archived,
      }))
    },
    searchTargetEnvironments(name, selectedItems) {
      let selectedItemNames = selectedItems.map((i) => i.text)
      let excludedName = []
      if (this.$attrs['additional-options']) {
        excludedName = (this.$attrs['additional-options'] || []).map(
          (o) => o.text || o.name || o.label
        )
      }
      let excludedId = []
      if (this.$attrs['additional-options']) {
        excludedId = (this.$attrs['additional-options'] || []).map(
          (o) => o.key || o.id || o.value
        )
      }
      selectedItemNames = selectedItemNames.filter(
        (s) => excludedName.indexOf(s) === -1
      )
      if (this.value && !this.isDirty) {
        let ids = Array.isArray(this.value) ? this.value : [this.value]
        if (excludedId.length) {
          ids = ids.filter((i) => excludedId.indexOf(i) === -1) || []
        }
        return getTargetEnvironmentsApi({ ids }, ids.length || 10, 0, {
          archived: true,
        }).then((data) => {
          this.selectedValueOptions = data.items
          this.isDirty = true
          return data
        })
      }
      return getTargetEnvironmentsApi(
        {
          name,
          selectedName: selectedItemNames,
        },
        undefined,
        undefined,
        { archived: !!this.value }
      ).then((data) => {
        const ids = this.selectedValueOptions.map((i) => i.id)
        return {
          items: [
            ...data.items.filter(({ id }) => ids.indexOf(id) === -1),
            ...this.selectedValueOptions,
          ],
        }
      })
    },
  },
}
</script>
